import {Component, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'logout-dialog',
    templateUrl: 'logout-dialog.html',
    styleUrls: ['./logout-dialog.scss'],
    imports: [MatButton, MatDialogClose]
})
export class LogoutDialog {

    constructor(
        public dialogRef: MatDialogRef<LogoutDialog>,
        ) { }

    onNoClick(): void {
        this.dialogRef.close();
    }

}
